/** Short glosses for hero aside labels (UI copy, not CMS). */
export const HERO_ASIDE_TOOLTIP_COPY: Record<string, string> = {
  client: 'The organization or product team this case study is about.',
  industry: 'The market or sector the work sits in.',
  focus_area: 'The primary practice area or workflow type (for example marketing ops).',
  human_effort:
    'Focused human hours to produce this case study page: research, structuring, drafting, revision, and any diagrams or screenshots—not the old workflow runtime.',
  acceleration: 'How much faster or lighter the process became after changes—for example a time ratio or multiplier.',
  ai_handoff:
    'How much of the repetitive layer can move to AI, with people still reviewing and steering quality.',
  replicability: 'How easily you could reuse this workflow pattern in another team, brand, or company.',
}
